<template>
  <div class="sidebar-container">
    
    <!-- Open Tab Content -->
    <div v-if="selectedTab.name" class="full-content">
        
        <div v-if="selectedTab.name === 'Indicators'">
            <h2>Indicators</h2>
            <!-- Form for Indicators Tab -->
            <FormKit
                type="select"
                name="year"
                label="Year"
                :options="yearOptions"
                disabled="true"
            />
            <FormKit 
                v-model="selectedSoilProperty"
                type="radio"
                label="Soil Properties"
                :options="soilPropertiesOptions"
                @input="onInputChange"
            />
        </div>

        <div v-if="selectedTab.name === 'Search'">
            <!-- Form for Search Tab -->
            <h2>Search by Coordinates</h2>
            <br>
            <FormKit
                type="form"
                id="form-seach-by-coords"
                @submit="onSearchSubmit"
                :actions="false"
            >
                <FormKit
                    v-model="searchLat"
                    type="number"
                    label="Latitude"
                    help="Enter the latitude GPS coordinate"
                />
                <FormKit
                    v-model="searchLng"
                    type="number"
                    label="Longitude"
                    help="Enter the longitude GPS coordinate"
                />
                <FormKit
                    type="submit"
                    label="Search"
                    prefix-icon="search"
                />
            </FormKit>
        </div>   


        <div v-if="selectedTab.name == 'Download'" class="download-tab-container">
          <h2>Download</h2>
          <p>Draw a polygon to download the data.</p>
          <br>
          <div class="download-tab-button-group">
            <FormKit
              type="submit"
              label="Cancel"
              prefix-icon="close"
              :style="{backgroundColor: '#979dac', color: '#ffffff', flex: 1 }" 
              @click="handleCancelDraw"
            />
            <FormKit
                type="submit"
                label="Draw"
                prefix-icon="color"
                :style="{ flex: 1 }"
                @click="handleDraw"
            />
          </div>
        </div>

    </div>
    
    <div class="sidebar">
      <ul>
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: tab.active }"
          @click="clickTab(tab)"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>
  </div>

  
</template>

<script setup>
import { defineEmits, ref } from 'vue';

const searchLng = ref(null);
const searchLat = ref(null);
const drawEnabled = ref(false);


// Define emits
const emit = defineEmits(['getSoilProperty', 'getSearchCoords', 'getDrawEnabled']);

// Define your tabs and associated components
const tabs = [
  { name: 'Indicators', active: false },
  { name: 'Download', active: false },
  { name: 'Search', active: false },
]

// default values 
const selectedTab = ref({});
const selectedSoilProperty = ref('soc');


const clickTab = (tab) => {
    
    for (let i=0; i<tabs.length; i++) {
        tabs[i].active = false;
    }

    if (selectedTab.value.name != tab.name) {
        selectedTab.value = tab;
        tab.active = true;
    } 
    else {
        selectedTab.value = {};
    }
}

const onInputChange = (soilProperty) => {
    emit('getSoilProperty', soilProperty);
}


const onSearchSubmit = () => {
    emit('getSearchCoords', [Number(searchLat.value), Number(searchLng.value)]);
}

const handleDraw = () => {
  drawEnabled.value = true;
  emit('getDrawEnabled', drawEnabled.value);
}

const handleCancelDraw = () => {
  drawEnabled.value = false;
  emit('getDrawEnabled', drawEnabled.value);
}

/*const soilPropertiesOptions = {
    soc: 'Soil Organic Carbon (g/kg)',
    socs: 'Soil Organinc Carbon Sequestration (tn/ha)', 
    clay: 'Clay Content (g/kg)',
    ph: 'pH level',
    sd: 'Soil Density (g/cm³) ',
    cec: 'Cation Exchange Capacity (g/kg)', 
    paw: 'Plant Available Water (m³/m³)'
}*/
const soilPropertiesOptions = {
    soc: 'Soil Organic Carbon (g/kg)',
    clay: 'Clay Content (g/kg)',
    ph: 'pH level',
    cec: 'Cation Exchange Capacity (g/kg)', 
    paw: 'Plant Available Water (m³/m³)'
}
const yearOptions = {
    label: '2023', value: 2023
}


</script>

<style scoped>
.sidebar-container {
  display: flex;
  flex-grow: 1; 
  max-height: 100%;

  position: absolute; /* I need this for the SidePanel be over map component */
  z-index: 2; /* I need this for the SidePanel be over map component */
}


.full-content {
    width: 400px;
    //margin: 20px;
    padding: 20px;
    background-color: #ffffff;

}

.sidebar {
  width: 80px;
  color: #ffffff; /* white color for text */
  font-weight: bold;
  font-size: large;
  font-family: courier;
}

.sidebar ul {
  list-style-type: none;
}

.sidebar li {
  padding: 50px 15px;
  cursor: pointer;
  margin-bottom: 5px;
  border-radius: 25px 0px 0px 25px;
  background-color: #14213d;
  writing-mode: vertical-rl; /* Makes the text vertical */
  transform: rotate(180deg); /* Flips the text to read naturally */
}

.sidebar li:hover {  /* on hover of tab */
  background-color: #adb5bd;
}

.sidebar li.active {
  background-color: #adb5bd;
  //color: white;
}

.download-tab-container {
  font-family: courier;

}

.download-tab-button-group {
  display: flex;
  gap: 10px;
  justify-content: center;
}


</style>
